import React from 'react'
import { createContext, useContext } from "react";

export const listProvinces = createContext<string[]>([]);
export const minYear = createContext<number>(0);
export const backEndGeneo=createContext<string>("");
export const showError=createContext(false);
export const client = createContext("")